export default "__VITE_ASSET__CNHL_4Hb__"